import { Typography } from "@mui/material"
import { Stack } from "src/shared/components"
import DashboardBox from "src/modules/dashboard/componenets/dashboard-box"

const boxes = [
  { title: "Stock Available", value: "691,374" },
  { title: "Stock In", value: "691,374", type: "in" },
  { title: " Stock Out", value: "691,374", type: "out" }
]
const Dashboard = () => {
  return (
    <Stack position="relative" height={"100%"} p={2}>
      <Typography variant="h3">Dashboard</Typography>
      <Stack direction={"row"} justifyContent={"space-between"} gap={"10px"} flexWrap={"wrap"} mt={2}>
        {boxes.map((box, index) => (
          <DashboardBox key={index} title={box.title} value={box.value} type={box.type} />
        ))}
      </Stack>
    </Stack>
  )
}

export default Dashboard
